interface DefaultLayoutProps {
  children: React.ReactNode
}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  return <div className="h-full w-full min-h-dvh">{children}</div>
}
